import React from "react";
import { Route, Switch } from "react-router-dom";
import DraftSchedules from "components/schedule/DraftSchedules";
import EditDraftSchedule from "components/schedule/EditDraftSchedule";
import DraftsDetails from "components/schedule/DraftsDetails";
import Dashboard from "components/dashboard/Dashboard";

import PrivateRoute from "components/common/PrivateRoute";
import NotFound from "components/Extra/NotFound";

const AppRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/drafts`}
                component={DraftSchedules}
            />
            <PrivateRoute
                exact
                path={`${props.match.url}/drafts/:id`}
                component={EditDraftSchedule}
            />
            <PrivateRoute
                exact
                path={`${props.match.url}/drafts/details/:ids`}
                component={DraftsDetails}
            />

            <Route
                exact
                path={`${props.match.url}/user`}
                component={Dashboard}
            />
            <Route component={NotFound}/>
        </Switch>
    </div>
);

export default AppRouter;
